export default {
    LOGIN_IN(state, token) {
        state.userInfo = token
    },
    LOGIN_OUT(state) {
        state.userInfo = ''
    },
    toggleHiddenMenu(state) {
        state.isHiddenMenu = true
    },
    toggleShowMenu(state) {
        state.isHiddenMenu = false
    },
    toggleHiddenTop(state) {
        state.isHiddenTop = true
    },
    toggleShowTop(state) {
        state.isHiddenTop = false
    },
    setUserInfo(state, user) {
        state.userInfo = user;
    },
    setCrumbList(state, list) {
        state.crumbList = list
    },
    toggleIsStatisticsPage(state) {
        state.isStatisticsPage = true
    },
    toggleNotStatisticsPage(state) {
        state.isStatisticsPage = false
    }
}